import { Link } from "react-router-dom";
import { useAuth, useLogout } from "@/hooks/useAuth";
import { AlphaBanner } from "@/components/AlphaBanner";

/**
 * Persistent top-bar used on Dashboard and case-level pages.
 * Mirrors the landing's header visual language:
 *   – blue/teal gradient logo square
 *   – frosted-glass backdrop
 *   – pill-shaped sign-out button
 *
 * Renders the closed-alpha banner directly below itself so every
 * post-login page (dashboard, wizard, workspace, case detail) shows
 * the disclosure once VITE_ALPHA_MODE is on.
 */
export function AppHeader() {
  const { user } = useAuth();
  const logout = useLogout();

  return (
    <>
    <header className="sticky top-0 z-40 bg-white/70 backdrop-blur-xl border-b border-slate-200/60 shadow-sm">
      <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
        {/* Logo */}
        <Link to="/dashboard" className="flex items-center gap-2.5 group">
          <div className="w-8 h-8 rounded-xl bg-gradient-to-br from-blue-600 to-teal-500 flex items-center justify-center transition-transform duration-200 group-hover:scale-105 shadow-sm">
            {/* Sparkle-style star */}
            <svg className="w-4 h-4 text-white" fill="none" viewBox="0 0 16 16" stroke="currentColor" strokeWidth="1.8">
              <path strokeLinecap="round" strokeLinejoin="round" d="M8 1v14M1 8h14M4.5 4.5l7 7M11.5 4.5l-7 7" />
            </svg>
          </div>
          <span className="text-base font-bold tracking-tight text-slate-900 font-display">
            GetCitizen <span className="text-blue-600">AI</span>
          </span>
        </Link>

        {/* Right side */}
        {user && (
          <div className="flex items-center gap-3">
            <span className="hidden sm:block text-sm text-slate-500">{user.primary_email}</span>
            <button
              onClick={() => logout.mutate()}
              className="text-sm font-medium text-slate-500 hover:text-slate-900 px-3.5 py-1.5 rounded-full border border-slate-200 hover:border-slate-300 hover:bg-slate-50 transition-all"
            >
              Sign out
            </button>
          </div>
        )}
      </div>
    </header>
    <AlphaBanner />
    </>
  );
}
